import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Slideshow from "./sections/Slideshow";
import OurServices from "./sections/OurServices";
import WhyChooseAAEaglePlumbing from "./sections/WhyChooseAAEaglePlumbing";
import GetAFreeEstimate from "./sections/GetAFreeEstimate";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <Slideshow />
      <OurServices />
      <WhyChooseAAEaglePlumbing />
      <GetAFreeEstimate />
      <Footer />
    </div>;
}